import React from 'react';
import { FeaturesNames } from 'src/definitions/custom-models';
import { useFeatureFlags } from './useFeatureFlags';

interface Props {
  featureId?: FeaturesNames;
  subFeatureId?: string;
}

export const IsFeatureOn: React.FC<React.PropsWithChildren<Props>> = ({ featureId, subFeatureId, children }) => {
  const { isEnabled, isEnabledSubFeature } = useFeatureFlags();
  if (subFeatureId && featureId) {
    return isEnabledSubFeature(featureId, subFeatureId) ? children : null;
  }
  return !featureId || isEnabled(featureId) ? children : null;
};
